<button class="btn btn-outline-primary mb-3" routerLink="/seo/work-history" fragment="{{id}}"><i class="fa fa-arrow-left"></i> {{ 'navigation_seo_work_history' | translate }}</button>
<div #target></div>
